export { default as CubesOutlineIcon } from './CubesOutlineIcon';
